import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import { isValidPhone } from '#/shared/lib/format'

export interface CustomerFormData {
  firstName: string
  lastName: string
  company: string
  companyPhone: string
  billingEmail: string
  email: string
  phone: string
  mobile: string
  email2: string
  note: string
}

export const EMPTY_CUSTOMER_DEFAULTS: CustomerFormData = {
  firstName: '',
  lastName: '',
  company: '',
  companyPhone: '',
  billingEmail: '',
  email: '',
  phone: '',
  mobile: '',
  email2: '',
  note: '',
}

export function useCustomerSchema() {
  const { t } = useTranslation()

  const required = t('forms.validation.required')
  const invalidEmail = t('forms.validation.invalidEmail')
  const invalidPhone = t('forms.validation.invalidUsPhone')

  const optionalEmail = z
    .string()
    .optional()
    .default('')
    .refine((v) => v === '' || z.string().email().safeParse(v).success, {
      message: invalidEmail,
    })

  const optionalUsPhone = z
    .string()
    .optional()
    .default('')
    .refine((value) => value === '' || isValidPhone(value), {
      message: invalidPhone,
    })

  return z.object({
    firstName: z.string().optional().default(''),
    lastName: z.string().optional().default(''),
    company: z.string().optional().default(''),
    companyPhone: optionalUsPhone,
    billingEmail: optionalEmail,
    email: z.string().min(1, required).email(invalidEmail),
    phone: optionalUsPhone,
    mobile: optionalUsPhone,
    email2: optionalEmail,
    note: z.string().optional().default(''),
  })
}
